import { jsx } from 'react/jsx-runtime';
import { useState, Suspense } from 'react';
import '../../node_modules/@zooplus/commons-lang/dist/es/gen/lang.js';
import { findDeploymentEnvFromUrl } from '../../node_modules/@zooplus/commons-lang/dist/es/services/envService.js';
import '../../node_modules/@zooplus/commons-lang/dist/es/components/SiteProvider.js';
import { AppProvider } from '../../context/AppContext.js';
import { useI18n } from '../../translations/index.js';
import { initializeSentry } from '../../utils/sentryHub.js';
import Account from '../Account/Account.js';
import AccountMobileButton from '../AccountMobileButton/AccountMobileButton.js';
import { useBreakpointsMatching } from '../../node_modules/@zooplus/myaccount-utils/dist/es/hooks/useBreakpointsMatching/useBreakpointsMatching.js';

const HeaderAccountFlyoutComponent = ({ locale, bundle, domain, hasBonusPoints, onFlyoutClick, selectedTheme, }) => {
    initializeSentry(findDeploymentEnvFromUrl());
    const [showFlyout, setShowFlyout] = useState(false);
    useI18n(bundle, locale);
    const breakpoint = useBreakpointsMatching();
    const isMobile = breakpoint.match('SMARTPHONE', 'PHABLET');
    const FlyOutComponent = isMobile ? AccountMobileButton : Account;
    return (jsx(AppProvider, { hasBonusPoints: hasBonusPoints, domain: domain, selectedTheme: selectedTheme, bundle: bundle, children: jsx(Suspense, { fallback: null, children: jsx(FlyOutComponent, { showFlyout: showFlyout, setShowFlyout: setShowFlyout, onFlyoutClick: onFlyoutClick }) }) }));
};
HeaderAccountFlyoutComponent.displayName = 'HeaderAccountFlyoutComponent';

export { HeaderAccountFlyoutComponent as default };
//# sourceMappingURL=HeaderAccountFlyoutComponent.js.map
